import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/Login";
import HomePage from "@/pages/Home";
import EmailsPage from "@/pages/Emails";
import EmailDetailPage from "@/pages/EmailDetail";
import OpportunitiesPage from "@/pages/Opportunities";
import OpportunityDetailPage from "@/pages/OpportunityDetail";
import ValuePage from "@/pages/Value";
import OperationsPage from "@/pages/Operations";
import SearchPage from "@/pages/SearchPage";
import SettingsPage from "@/pages/SettingsPage";
import AuditPage from "@/pages/AuditPage";
import "@/App.css";

function RequireAuth({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Shell() {
  return (
    <AppLayout>
      <Routes>
        <Route path="/"                       element={<HomePage />} />
        <Route path="/emails"                 element={<EmailsPage />} />
        <Route path="/emails/:id"             element={<EmailDetailPage />} />
        <Route path="/opportunities"          element={<OpportunitiesPage />} />
        <Route path="/opportunities/:id"      element={<OpportunityDetailPage />} />
        <Route path="/value"                  element={<ValuePage />} />
        <Route path="/operations"             element={<OperationsPage />} />
        <Route path="/search"                 element={<SearchPage />} />
        <Route path="/settings"               element={<SettingsPage />} />
        <Route path="/audit"                  element={<AuditPage />} />
        <Route path="*"                       element={<Navigate to="/" replace />} />
      </Routes>
    </AppLayout>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/*" element={<RequireAuth><Shell /></RequireAuth>} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
